<div style="margin: auto">
    <app-animal-marker-svg [animalType]="animalType"
                           [hasWarning]="hasWarning"
                           [width]="width"
                           [height]="height"
                           style="margin: auto"></app-animal-marker-svg>
    <div style="font-size: var(--main-font-size);
                color: #FFFFFF;
                margin: auto;
                text-align: center;
                justify-content: center;
                text-shadow: 1px 0 0 #000, 0 -1px 0 #000, 0 1px 0 #000, -1px 0 0 #000;">{{ name }}
    </div>
</div>
